const generalReducer = (state = {}, action) => {
  const { type, ...data } = action
  switch (type) {
    case 'show-switch-site': {
      return { ...state, switchSiteModalOpen: data.open }
    }
    case 'sites': {
      return { ...state, sites: data.sites }
    }
    case 'select-site': {
      return { ...state, site: data.site }
    }
    case 'set-site-settings': {
      return { ...state, settings: data.settings }
    }
    case 'insert-template-modal': {
      return { ...state, InsertTemplateModal: data }
    }
    case 'select-language-data': {
      return { ...state, selectedLanguageData: data.data }
    }
    case 'selected-tab': {
      return { ...state, selectedTab: data.data }
    }
    case 'open-assets': {
      return { ...state, openAssets: data.data }
    }
    case 'image-mutator-value': {
      return { ...state, imageMutatorValue: data.data }
    }
    case 'edit-json': {
      return { ...state, editJsonData: data.data, editJsonDataTranslation: data.dataTranslation }
    }
    case 'custom-editor': {
      return { 
        ...state, 
        customEditor: {
          editor: data.editor, 
          data: data.data 
        }
      }
    }
    case 'show-notification': {
      const notification = {
        id: Math.round(Math.random() * 10000000).toString(),
        content: data.content,
        severity: data.severity,
        duration: data.duration
      }
      return { ...state, notifications: [ ...(state.notifications || []), notification ]}
    }
    case 'close-notification': {
      const notifications = (state.notifications || []).filter(notification => notification.id !== data.id)
      return {  ...state, notifications }
    }
    default:
      return state;
  }
};

export default generalReducer;
